<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-home-info">
    <strong class="ren-decoration-cp-scenic-home-info__name">{{ name }}</strong>

    <div
      v-if="showRating || showPrice"
      class="ren-decoration-cp-scenic-home-info__meta">
      <span v-if="showRating && scenic.hasRank" class="ren-decoration-cp-scenic-home-info__rating">
        ★ {{ scenic.rank }}
      </span>
      <span v-else-if="showRating" class="ren-decoration-cp-scenic-home-info__no-score">暂无评分</span>
      <span v-if="showPrice" class="ren-decoration-cp-scenic-home-info__price">
        ¥{{ scenic.pricePerPerson }}/人
      </span>
    </div>

    <template v-if="showBusinessHours || showLocation">
      <i class="ren-decoration-cp-scenic-home-info__divider" aria-hidden="true"></i>
      <div v-if="showBusinessHours" class="ren-decoration-cp-scenic-home-info__line">
        <b :class="{ 'is-open': scenic.businessStatusCode === 'OPEN' }">{{ statusText }}</b>
        <span>{{ scenic.hours }}</span>
      </div>
    </template>

    <div v-if="showLocation" class="ren-decoration-cp-scenic-home-info__line">
      <span class="ren-decoration-cp-scenic-home-info__addr">
        {{ scenic.address }}
        <em v-if="scenic.distanceKm">距您 {{ scenic.distanceKm }}km</em>
      </span>
      <span class="ren-decoration-cp-scenic-home-info__tool">导</span>
      <span class="ren-decoration-cp-scenic-home-info__tool">话</span>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import {
  SAMPLE_SCENIC,
  scenicStatusText,
  type ScenicPreviewScenic
} from '../../scenic-preview-data'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const scenic = computed<ScenicPreviewScenic>(() => ({
  ...SAMPLE_SCENIC,
  ...(stringValue(props.component.props?.name) ? { name: stringValue(props.component.props?.name) } : {})
}))
const name = computed(() => scenic.value.name)
const statusText = computed(() => scenicStatusText(scenic.value.businessStatusCode))
const showRating = computed(() => booleanValue(props.component.props?.showRating, true))
const showPrice = computed(() => booleanValue(props.component.props?.showPrice, true))
const showBusinessHours = computed(() => booleanValue(props.component.props?.showBusinessHours, true))
const showLocation = computed(() => booleanValue(props.component.props?.showLocation, true))
</script>

<style scoped>
.ren-decoration-cp-scenic-home-info {
  display: grid;
  gap: 8px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-home-info__name {
  color: var(--ren-theme-text);
  font-size: 15px;
}
.ren-decoration-cp-scenic-home-info__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}
.ren-decoration-cp-scenic-home-info__rating {
  color: var(--ren-theme-accent);
}
.ren-decoration-cp-scenic-home-info__no-score,
.ren-decoration-cp-scenic-home-info__price {
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-scenic-home-info__divider {
  height: 1px;
  background: var(--ren-theme-border);
}
.ren-decoration-cp-scenic-home-info__line {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ren-theme-text);
  font-size: 12px;
}
.ren-decoration-cp-scenic-home-info__line b {
  font-weight: 600;
}
.ren-decoration-cp-scenic-home-info__line b.is-open {
  color: var(--ren-theme-primary);
}
.ren-decoration-cp-scenic-home-info__addr {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ren-decoration-cp-scenic-home-info__addr em {
  font-style: normal;
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-scenic-home-info__tool {
  flex-shrink: 0;
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--ren-theme-primary);
  color: #fff;
  font-size: 10px;
}
</style>
